import { render } from "./MainView.vue?vue&type=template&id=606f6fb6"
import script from "./MainView.vue?vue&type=script&lang=js"
export * from "./MainView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/guangdong.chen/development/ATech/frontend/app/gantt-elastic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__